import { useMemo } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { sanitiseFilters, urlFilters } from '@/components/FilterBar/filters';
import { UsersPage } from '@/features/users/UsersPage';
import { USER_FILTER_GROUPS } from '@/features/users/userFilters';

/*
  The sidebar calls it Relationship managers, as the legacy admin did so the team finds it where
  they expect (decision with Franka, 23 Aug 2026); the page calls itself Users, because it holds
  every staff account and being a relationship manager is one switch on an account.

  The applied filters ride the URL so a filtered list can be shared and survives a reload
  (ALS-104). Every key is an optional string here and nothing more: which values a choice filter
  accepts is a property of the filters, so `sanitiseFilters` decides that beside them rather than
  the schema repeating each option list. `.catch(undefined)` keeps a junk value from throwing the
  route, the way the product registers' `?register=` lands on the first tab.
*/
const filterParam = z.string().optional().catch(undefined);

const usersSearch = z.object({
    firstName: filterParam,
    lastName: filterParam,
    displayName: filterParam,
    email: filterParam,
    phone: filterParam,
    state: filterParam,
    role: filterParam,
});

export const Route = createFileRoute('/_app/relationship-managers')({
    validateSearch: (search) => usersSearch.parse(search),
    component: UsersRoute,
});

function UsersRoute() {
    const raw = Route.useSearch();
    const navigate = useNavigate();
    const applied = useMemo(() => sanitiseFilters(USER_FILTER_GROUPS, raw), [raw]);
    return (
        <UsersPage
            applied={applied}
            onFiltersChange={(next) =>
                void navigate({
                    to: '/relationship-managers',
                    search: urlFilters(USER_FILTER_GROUPS, next),
                    replace: true,
                    resetScroll: false,
                })
            }
        />
    );
}
